import React from 'react';
import './App.css';
import NavigationMenu from './components/NavigationMenu';
import Home from './pages/home';
import About from './pages/about';
import Work from './pages/work';
import AchievementsPage from './pages/achievements';
import MembersPage from './pages/members';
import GovernancePage from './pages/governance';
import NewsPage from './pages/news';
import ContactPage from './pages/contact';

function App() {
  const [currentPage, setCurrentPage] = React.useState('home');
  const [scrollTarget, setScrollTarget] = React.useState(null);

  const handleNavigate = (page, target = null) => {
    setCurrentPage(page);
    if (target) {
      setScrollTarget(target);
    }
  };

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [currentPage]);

  React.useEffect(() => {
    if (!scrollTarget) return undefined;

    const pagesWithScroll = ['members', 'contact'];
    if (!pagesWithScroll.includes(currentPage)) return undefined;

    const timer = window.setTimeout(() => {
      document.getElementById(scrollTarget)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setScrollTarget(null);
    }, 150);

    return () => window.clearTimeout(timer);
  }, [currentPage, scrollTarget]);

  const renderPage = () => {
    switch (currentPage) {
      case 'achievements':
        return <AchievementsPage onNavigate={handleNavigate} />;
      case 'members':
        return <MembersPage onNavigate={handleNavigate} />;
      case 'governance':
        return <GovernancePage />;
      case 'about':
        return <About />;
      case 'work':
        return <Work />;
      case 'news':
        return <NewsPage />;
      case 'contact':
        return <ContactPage />;
      case 'home':
      default:
        return <Home onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="App">
      <NavigationMenu currentPage={currentPage} onNavigate={handleNavigate} />
      {renderPage()}
    </div>
  );
}

export default App;
